import React from 'react';

const ForAuthor = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width={57}
      height={72}
      viewBox='0 0 57 72'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M46.2294 60.4224L29.1437 47.8523C27.0412 46.4871 24.1539 47.2422 23.1224 49.5269C23.0896 49.5994 23.0587 49.6735 23.0297 49.7488C22.0401 52.3214 24.0427 54.9342 26.959 56.1149L45.4576 63.0745L46.2294 60.4224Z'
        fill='#A9715B'
      />
      <path
        d='M44.5039 62.0916C44.5039 62.0916 45.997 64.8154 48.7036 64.997L50.8065 66.5574C51.133 66.7997 51.5879 66.7643 51.8732 66.4745C52.1818 66.1607 52.1858 65.6586 51.8818 65.3401L50.7948 64.2009L51.3245 64.3467C52.1656 64.5783 52.9037 65.0871 53.4196 65.7905L54.888 67.7927C55.0552 68.0205 55.3329 68.1392 55.6131 68.1025C56.1546 68.0315 56.4544 67.437 56.1895 66.9593L54.5992 64.0909C53.9828 62.9793 52.9171 62.1873 51.6749 61.9183L46.2292 60.4297L44.5039 62.0916Z'
        fill='#A9715B'
      />
      <path
        d='M24.4139 28.2578C24.4139 28.2578 33.2341 29.932 33.0901 39.0889C32.9959 45.0877 34.1246 50.4025 33.8527 53.0903C33.5923 55.6636 31.6147 58.3372 29.043 58.6133C28.0919 58.7154 26.0904 58.0768 25.0178 57.4978L22.3145 43.0048L24.4139 28.2578Z'
        fill='#E4AE6D'
      />
      <path
        d='M6.89918 58.4297L6.33936 71.0007H31.745L31.1854 58.4578L6.89918 58.4297Z'
        fill='#6349CE'
      />
      <path
        d='M26.8258 66.7969L16.9883 68.41'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.0889 67.8281L21.0889 70.9975'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.53027 56.0859L6.53027 59.5474C6.53027 59.5474 15.0523 62.2598 31.3693 59.5717L31.185 56.0859H6.53027Z'
        fill='black'
      />
      <path
        d='M18.2642 57.0806L18.3476 61.2817L23.9134 61.1222L23.8294 56.8984L18.2642 57.0806Z'
        fill='white'
      />
      <path
        d='M8.10258 29.6875C5.34285 31.025 1.4339 33.9709 1.52718 39.9094C1.62139 45.9082 -0.24462 51.4073 0.0272827 54.0952C0.287691 56.6684 1.99241 59.5212 6.14443 59.5212C7.78828 59.5212 9.3871 58.8951 10.1706 57.8532L10.3584 56.8459C15.2706 57.3562 23.029 57.6723 31.1853 56.0756L30.4478 37.3816C30.4478 37.3816 30.5082 36.1201 30.0479 34.4766L20.508 36.1233L8.10258 29.6875Z'
        fill='#E4AE6D'
      />
      <path
        d='M24.5763 28.1719L10.9403 28.6656C10.9403 28.6656 10.9035 28.6885 10.8285 28.7181C10.8054 28.7272 10.7835 28.7373 10.7605 28.7466L10.7566 28.7181C10.7566 28.7181 9.59828 28.9712 8.10272 29.6961L20.5083 36.1319L30.0483 34.4852C29.4636 32.3972 28.0381 29.6929 24.5763 28.1719Z'
        fill='#EDBC84'
      />
      <path
        d='M16.6999 31.026L19.5486 34.0766L22.2681 30.4479L19.1647 29.3203L16.6999 31.026Z'
        fill='black'
      />
      <path
        d='M19.0673 32.8057L17.1555 52.2143L20.7693 56.2847L23.5812 51.9371L19.8291 32.6953L19.0673 32.8057Z'
        fill='black'
      />
      <path
        d='M13.5194 26.8203L10.9396 28.6716L15.4527 33.5127L19.1647 29.3217L13.5194 26.8203Z'
        fill='#EDBC84'
      />
      <path
        d='M19.1647 29.3217L22.7477 32.967L24.5756 28.1781L21.8001 26.8203L19.1647 29.3217Z'
        fill='#EDBC84'
      />
      <path
        d='M24.5756 28.1719L22.7477 32.9608L19.1647 29.3154L15.4527 33.5065L10.9396 28.6654'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31.1001 56.0945L30.2053 35.1094'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.1219 41.3672L9.68378 51.4958'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M40.3155 19.1768L38.92 24.2607L37.8965 24.7168L39.2266 18.7715L40.3155 19.1768Z'
        fill='#EFE4D8'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <path
        d='M38.4817 23.7002L37.9368 25.9619L24.8636 22.082L25.6292 18.918L38.4817 23.7002Z'
        fill='#EFE4D8'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <path
        d='M40.7106 18.7256L39.2907 23.9961L39.0886 24.1543L40.57 18.6553L40.7106 18.7256Z'
        fill='#FF5612'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <path
        d='M36.2764 23.7939C36.2794 23.7966 36.282 23.7999 36.2852 23.8027C36.3208 23.8345 36.3722 23.8782 36.4375 23.9277C36.5678 24.0265 36.7569 24.1513 36.9922 24.2559C37.3672 24.4225 37.8659 24.5374 38.4278 24.4092L35.1416 38.04L35.1045 38.1094C35.0712 38.1702 35.0205 38.2569 34.9541 38.3574C34.8205 38.5599 34.6264 38.8122 34.3789 39.0244C34.1314 39.2367 33.841 39.4003 33.5137 39.4463C33.1917 39.4914 32.8067 39.4266 32.3555 39.1357L32.3233 39.1152L32.2862 39.1045L20.8057 35.9551L24.4092 20.3291L36.2764 23.7939Z'
        fill='#FF5612'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <path
        d='M36.7012 23.9219C36.9344 23.9852 37.2585 24.0592 37.6192 24.1006C38.1294 24.1591 38.755 24.156 39.2989 23.9287L35.586 37.9883C35.5751 38.0041 35.5609 38.0266 35.542 38.0527C35.497 38.1151 35.4295 38.2037 35.3428 38.3066C35.1683 38.5138 34.9186 38.7738 34.6143 38.9941C34.3094 39.2148 33.9602 39.3882 33.584 39.4385C33.2336 39.4852 32.8456 39.4259 32.4268 39.1758L36.4239 23.8398C36.49 23.8614 36.5847 23.8902 36.7012 23.9219Z'
        fill='#FF5612'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <mask id='path-23-inside-1_22334_31246' fill='white'>
        <path d='M21.4981 35.2793L24.8367 21.0906L24.8506 21.0312L35.3772 24.1134L31.5506 38.1988L31.5351 38.2557L21.4981 35.2793ZM24.935 21.1763L21.6353 35.1996L31.4546 38.1115L35.236 24.1925L24.935 21.1763Z' />
      </mask>
      <path
        d='M21.4981 35.2793L24.8367 21.0906L24.8506 21.0312L35.3772 24.1134L31.5506 38.1988L31.5351 38.2557L21.4981 35.2793ZM24.935 21.1763L21.6353 35.1996L31.4546 38.1115L35.236 24.1925L24.935 21.1763Z'
        fill='#806CEF'
      />
      <path
        d='M21.4981 35.2793L21.0114 35.1648L20.9032 35.6244L21.3559 35.7586L21.4981 35.2793ZM24.8367 21.0906L25.3234 21.2051L25.3234 21.205L24.8367 21.0906ZM24.8506 21.0312L24.9911 20.5514L24.4846 20.4031L24.3638 20.9169L24.8506 21.0312ZM35.3772 24.1134L35.8597 24.2445L35.9882 23.7713L35.5177 23.6335L35.3772 24.1134ZM31.5506 38.1988L31.068 38.0677L31.068 38.0678L31.5506 38.1988ZM31.5351 38.2557L31.393 38.7351L31.8835 38.8806L32.0176 38.3867L31.5351 38.2557ZM24.935 21.1763L25.0755 20.6965L24.5692 20.5482L24.4483 21.0618L24.935 21.1763ZM21.6353 35.1996L21.1485 35.085L21.0404 35.5447L21.4931 35.6789L21.6353 35.1996ZM31.4546 38.1115L31.3125 38.5909L31.803 38.7364L31.9372 38.2426L31.4546 38.1115ZM35.236 24.1925L35.7185 24.3236L35.8471 23.8504L35.3765 23.7127L35.236 24.1925ZM21.4981 35.2793L21.9848 35.3938L25.3234 21.2051L24.8367 21.0906L24.3499 20.9761L21.0114 35.1648L21.4981 35.2793ZM24.8367 21.0906L25.3234 21.205L25.3373 21.1456L24.8506 21.0312L24.3638 20.9169L24.3499 20.9763L24.8367 21.0906ZM24.8506 21.0312L24.7101 21.5111L35.2367 24.5932L35.3772 24.1134L35.5177 23.6335L24.9911 20.5514L24.8506 21.0312ZM35.3772 24.1134L34.8946 23.9823L31.068 38.0677L31.5506 38.1988L32.0331 38.3299L35.8597 24.2445L35.3772 24.1134ZM31.5506 38.1988L31.068 38.0678L31.0526 38.1247L31.5351 38.2557L32.0176 38.3867L32.0331 38.3298L31.5506 38.1988ZM31.5351 38.2557L31.6773 37.7763L21.6402 34.7999L21.4981 35.2793L21.3559 35.7586L31.393 38.7351L31.5351 38.2557ZM24.935 21.1763L24.4483 21.0618L21.1485 35.085L21.6353 35.1996L22.122 35.3141L25.4217 21.2909L24.935 21.1763ZM21.6353 35.1996L21.4931 35.6789L31.3125 38.5909L31.4546 38.1115L31.5968 37.6322L21.7774 34.7202L21.6353 35.1996ZM31.4546 38.1115L31.9372 38.2426L35.7185 24.3236L35.236 24.1925L34.7535 24.0614L30.9721 37.9805L31.4546 38.1115ZM35.236 24.1925L35.3765 23.7127L25.0755 20.6965L24.935 21.1763L24.7945 21.6562L35.0955 24.6724L35.236 24.1925Z'
        fill='#FFA870'
        mask='url(#path-23-inside-1_22334_31246)'
      />
      <path
        d='M31.8609 26.208L31.5308 27.3906L26.1724 25.9189L26.5025 24.7363L31.8609 26.208Z'
        fill='white'
        stroke='#FFA870'
        strokeWidth='0.5'
      />
      <path
        d='M35.7159 25.5703C35.7159 25.5703 37.6026 26.9055 39.0463 25.5703'
        stroke='#FFA870'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M35.4917 26.6172C35.4917 26.6172 37.3334 27.9524 38.7771 26.6172'
        stroke='#FFA870'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.599 35.7134C33.6906 35.5629 33.703 35.3793 33.6371 35.2182C33.4758 34.8238 32.915 34.7867 32.6565 35.1253C31.2755 36.9344 30.4762 37.1021 30.4762 37.1021C31.3989 36.16 32.3691 34.655 32.7972 33.8531C32.9124 33.6373 32.8634 33.3682 32.6687 33.2043C32.4268 33.0004 32.0601 33.0863 31.8798 33.3464C30.6269 35.1517 29.0332 36.2273 29.0332 36.2273C29.7647 35.2672 30.5798 33.3771 30.9472 32.4775C31.0505 32.2245 30.8885 31.9428 30.6179 31.9047C30.4896 31.8866 30.3622 31.8544 30.1251 32.044C29.7581 32.3375 29.4828 33.1076 27.8223 35.3891C26.1222 37.7253 23.7798 37.0403 23.7798 37.0403C23.0234 38.4739 22.9818 39.7058 22.9818 39.7058L21.7506 42.0932L24.236 43.3012L26.0894 42.3152C27.9105 42.224 29.9439 41.1194 31.3192 39.7482C31.8651 39.2039 33.016 38.0392 33.2519 37.7021C33.3987 37.4926 33.196 37.0524 32.7978 37.3179L31.0467 38.511L32.2834 37.3456C32.8106 36.8406 33.3277 36.16 33.599 35.7134Z'
        fill='#A9715B'
      />
      <path
        d='M22.9817 39.7031L5.55604 51.0445C3.45506 52.4119 2.97325 55.3572 4.64273 57.2272C4.69586 57.2865 4.75089 57.3449 4.80798 57.402C6.75765 59.3506 9.9583 58.5807 12.2209 56.3947L26.0893 42.3127L22.9817 39.7031Z'
        fill='#A9715B'
      />
      <path
        d='M12.6634 13.5859L13.7045 16.9068L15.2989 14.1418L12.6634 13.5859Z'
        fill='black'
      />
      <path
        d='M21.5301 1.94248C21.5301 1.94248 25.4749 0.464634 25.2938 4.51811C25.1127 8.5714 23.8742 10.037 23.8742 10.037L21.5301 1.94248Z'
        fill='black'
      />
      <path
        d='M21.8002 26.8087L19.1649 29.3101L13.5195 26.8087L13.704 13.5859H20.6759L21.8002 26.8087Z'
        fill='#A9715B'
      />
      <path
        d='M15.3514 20.0044L21.6106 24.7366L21.2055 19.1094L15.3514 20.0044Z'
        fill='black'
      />
      <path
        d='M26.2515 12.5795C26.462 11.2877 25.5854 10.07 24.2937 9.85955C23.002 9.6491 21.7842 10.5257 21.5738 11.8174C21.3633 13.1091 22.2399 14.3268 23.5316 14.5373C24.8233 14.7477 26.0411 13.8712 26.2515 12.5795Z'
        fill='#975D4A'
      />
      <path
        d='M24.2451 6.90506L24.2451 16.4444C24.2451 19.1836 21.9233 21.4041 19.0591 21.4041C16.195 21.4041 13.6793 19.1836 13.6793 16.4444L13.6793 6.90506C13.6793 4.20167 16.137 1.9963 18.963 1.94618C21.8643 1.89474 24.2451 4.12988 24.2451 6.90506Z'
        fill='#A9715B'
      />
      <path
        d='M21.4662 10.7422L22.5306 14.5784C22.5315 14.5818 22.5323 14.5852 22.5332 14.5886C22.6476 15.0346 22.309 15.4723 21.8513 15.5211L21.5131 15.5573'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.83 10.6219C19.83 10.8877 19.6146 11.1031 19.3488 11.1031C19.0829 11.1031 18.8675 10.8877 18.8675 10.6219C18.8675 10.356 19.0831 10.1406 19.3488 10.1406C19.6145 10.1406 19.83 10.356 19.83 10.6219Z'
        fill='black'
      />
      <path
        d='M23.4155 10.6219C23.4155 10.8877 23.1999 11.1031 22.9342 11.1031C22.6685 11.1031 22.453 10.8877 22.453 10.6219C22.453 10.356 22.6685 10.1406 22.9342 10.1406C23.1999 10.1406 23.4155 10.356 23.4155 10.6219Z'
        fill='black'
      />
      <path
        d='M19.6121 8.08613H17.5449C17.1803 8.08613 16.8846 7.79049 16.8846 7.42588C16.8846 7.06127 17.1803 6.76562 17.5449 6.76562H19.6121C19.9767 6.76562 20.2724 7.06127 20.2724 7.42588C20.2724 7.79049 19.9767 8.08613 19.6121 8.08613Z'
        fill='black'
      />
      <path
        d='M23.9274 8.08613H22.6293C22.2647 8.08613 21.9691 7.79049 21.9691 7.42588C21.9691 7.06127 22.2647 6.76562 22.6293 6.76562H23.9274C24.292 6.76562 24.5877 7.06127 24.5877 7.42588C24.5875 7.79049 24.292 8.08613 23.9274 8.08613Z'
        fill='black'
      />
      <path
        d='M19.6156 16.1094C19.6156 16.1094 20.2189 16.8167 21.5308 16.5126'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        opacity='0.12'
        d='M18.89 13.1565H18.5107C17.3289 13.1565 16.3709 12.1986 16.3709 11.0167L16.3709 9.71094H21.0298L21.0298 11.0167C21.0298 12.1986 20.0716 13.1565 18.89 13.1565Z'
        fill='#FCFFFF'
      />
      <path
        opacity='0.12'
        d='M23.7869 13.1564C22.7445 13.1564 21.8996 12.3114 21.8996 11.2691L21.8996 9.71094H25.6742L25.6742 11.2691C25.6742 12.3114 24.8293 13.1564 23.7869 13.1564Z'
        fill='#FCFFFF'
      />
      <path
        d='M18.89 13.1565H18.5107C17.3289 13.1565 16.3709 12.1986 16.3709 11.0167L16.3709 9.71094H21.0298L21.0298 11.0167C21.0298 12.1986 20.0716 13.1565 18.89 13.1565Z'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.7869 13.1564C22.7445 13.1564 21.8996 12.3114 21.8996 11.2691L21.8996 9.71094H25.6742L25.6742 11.2691C25.6742 12.3114 24.8293 13.1564 23.7869 13.1564Z'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.8794 10.8379C21.8794 10.8379 21.6111 10.4292 21.0526 10.8379'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.371 11.0164L14.2265 10.4766'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.7042 10.8066C13.7042 10.8066 14.6761 11.2193 14.4702 7.78328C14.264 4.34747 14.9147 3.06691 17.0066 3.57717C18.7543 4.0034 24.3335 3.7428 22.761 1.17245C21.3348 -1.15898 17.8445 0.706654 17.8445 0.706654C17.8445 0.706654 12.8877 0.14231 11.6309 3.06974C10.3741 5.99716 12.1595 10.8064 12.1595 10.8064L13.7042 10.8066Z'
        fill='black'
      />
      <path
        d='M14.6552 12.5853C14.8552 11.2919 13.9688 10.0813 12.6753 9.88131C11.3819 9.68133 10.1713 10.5677 9.97131 11.8612C9.77133 13.1546 10.6577 14.3652 11.9512 14.5652C13.2446 14.7652 14.4552 13.8788 14.6552 12.5853Z'
        fill='#A9715B'
      />
      <path
        d='M11.4505 11.1406L13.7043 12.8713'
        stroke='black'
        strokeWidth='0.5'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ForAuthor;
